import React from 'react';
import { SectorPageTemplate } from '../components/SectorPageTemplate';
export function SectorZakelijkeDienstverleningPage() {
  return <SectorPageTemplate sectorName="Zakelijke Dienstverlening" sectorSlug="zakelijke-dienstverlening" heroTitle="Website laten maken voor zakelijke dienstverlening" heroDescription="Professionele websites voor accountants, administratiekantoren, consultants en andere zakelijke dienstverleners. Wij bouwen websites die vertrouwen uitstralen en nieuwe klanten aantrekken." whyTitle="Waarom een goede website essentieel is voor zakelijke dienstverleners" whyDescription="Jouw website is vaak het eerste contactmoment met potentiële klanten. Maak die eerste indruk onvergetelijk." whyItems={[{
    icon: 'ShieldCheckIcon',
    title: 'Vertrouwen opbouwen',
    description: 'Klanten vertrouwen eerder op een accountant of consultant met een professionele online aanwezigheid.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokaal gevonden worden',
    description: 'Potentiële klanten zoeken online naar dienstverleners in hun regio. Zorg dat zij jou vinden.'
  }, {
    icon: 'TrendingUpIcon',
    title: 'Meer aanvragen genereren',
    description: 'Een conversiegerichte website zorgt voor een constante stroom van nieuwe klantaanvragen.'
  }, {
    icon: 'UsersIcon',
    title: 'Expertise tonen',
    description: 'Laat zien waar je goed in bent met een overzichtelijke presentatie van jouw diensten en specialisaties.'
  }]} features={[{
    icon: 'CalendarCheckIcon',
    title: 'Online afspraken inplannen',
    description: 'Laat klanten eenvoudig online een afspraak inplannen. Geen heen-en-weer gemail meer, direct een geschikt moment kiezen.'
  }, {
    icon: 'FileTextIcon',
    title: 'Contactformulieren',
    description: 'Slimme formulieren die de juiste informatie ophalen, zodat je direct kunt inspelen op de vraag van de klant.'
  }, {
    icon: 'BarChart3Icon',
    title: 'SEO vindbaarheid',
    description: 'Geoptimaliseerd voor zoektermen als "website accountant" en "administratiekantoor in de buurt", zodat klanten jou vinden.'
  }]} clusters={[{
    name: 'Accountant',
    slug: 'accountant',
    label: 'Financieel',
    description: 'Websites voor accountants, boekhouders en administratiekantoren.'
  }]} faqs={[{
    q: 'Wat kost een website voor een zakelijke dienstverlener?',
    a: "De kosten variëren afhankelijk van de complexiteit en het aantal pagina's. Een professionele website voor zakelijke dienstverlening begint vanaf €1.500. Neem contact op voor een vrijblijvende offerte op maat."
  }, {
    q: 'Hoe lang duurt het om een website te bouwen?',
    a: 'Gemiddeld is een website voor zakelijke dienstverlening binnen 2 tot 4 weken live. Dit hangt af van de omvang en hoe snel wij de benodigde content ontvangen.'
  }, {
    q: 'Kan ik zelf afspraken en content beheren?',
    a: 'Ja, wij bouwen op WordPress waardoor je eenvoudig zelf teksten, afbeeldingen en afspraken kunt beheren. Na oplevering geven wij een korte instructie.'
  }, {
    q: 'Wordt mijn website gevonden door potentiële klanten?',
    a: 'Absoluut. Elke website die wij bouwen is SEO-geoptimaliseerd. Wij zorgen ervoor dat je gevonden wordt op relevante zoektermen zoals "accountant Alkmaar" of "administratiekantoor in de buurt".'
  }]} relatedPages={[{
    name: 'Website laten maken',
    href: '#/website-laten-maken'
  }, {
    name: 'SEO voor websites',
    href: '#/seo-voor-websites'
  }]} data-id="element-1682" />;
}